module.exports = __webpack_public_path__ + "static/img/takagi_01.9b8b8f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/takagi_01.png
// module id = eauk
// module chunks = 0